import { useContext } from 'react';
import Styles from './InstructionCard.module.scss';
import { v4 as uuidv4 } from 'uuid';
import { ViewContext } from 'components/lib';

export function InstructionCard({ buttonText, ...props }) {

    const uuids = Array.from({ length: props.instructions.length }, () => uuidv4());
    const viewContext = useContext(ViewContext);

    return (
        <>
            <div id='instructionCard' className={Styles.instructionCard}>
                <div className={Styles.title}>
                    {viewContext.t('Components.InstructionCard.title')}
                </div>
                <div className={Styles.instructionsContainer}>
                    <ul>
                        {(props.instructions).map((value, index) => (
                            <li
                                id={`instr${index}`}
                                key={uuids[index]}
                                style={{
                                    fontWeight: index === props.instructions.length - 1 ? 700 : ''
                                }}
                            >
                                {value}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={Styles.buttonContainer}>
                    <button
                        className={Styles.backButton}
                        onClick={props.handleBackClick}
                    >
                        {buttonText ? buttonText : viewContext.t('Components.InstructionCard.button.back')}
                    </button>
                    <button
                        className={Styles.startButton}
                        onClick={props.handleStartClick}
                    >
                        {viewContext.t('Components.InstructionCard.button.start')}
                    </button>
                </div>
            </div>
        </>
    );
};